// Netplus "Complaints" module — shares the partner picker, styling tokens and
// date helpers with the Customer Status Report module.
export {
  usePartnerCode,
  PartnerPicker,
  panelClass,
  fieldClass,
  labelClass,
  btnPrimary,
  btnGhost,
  Badge,
  fmtDate,
  fmtDateInput,
} from "../customerStatus/config";

export const COMPLAINT_STATUS_TABS = [
  { key: "", label: "All" },
  { key: "open", label: "Open" },
  { key: "completed", label: "Completed" },
];

export const COMPLAINT_STATUS_TONE = {
  open: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};
